export const ENDLA_MANUAL_PROCESSING = "endla_manual_processing";
